import { render, staticRenderFns } from "./DaimonUpload.vue?vue&type=template&id=65caf0fd&scoped=true&"
import script from "./DaimonUpload.vue?vue&type=script&lang=ts&"
export * from "./DaimonUpload.vue?vue&type=script&lang=ts&"
import style0 from "./DaimonUpload.vue?vue&type=style&index=0&id=65caf0fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65caf0fd",
  null
  
)

export default component.exports